import React, { useCallback, useState } from 'react';

import SearchBar from 'components/SearchBar/SearchBar';
import { colors } from 'global/colors';
import {
  SkillContainer,
  Container,
  FriendAvatar,
  FriendName,
  FriendChallenge,
  FriendTable,
  FriendTableHeader,
  FriendTableCell,
  FriendTableRow,
  FriendTableHead,
  FriendTableBody,
  ItemContainer,
  FriendChallengeText,
} from './styles';

export default function FriendsTab({ profile }) {
  const { friends, trophies } = profile;

  const [searchQuery, setSearchQuery] = useState('');

  const getFilteredUsers = useCallback(() => {
    if (searchQuery) {
      return friends.filter((user) =>
        Object.values(user).some(
          (field) => field && String(field).toLowerCase().indexOf(searchQuery.toLowerCase()) > -1
        )
      );
    }
    return null;
  }, [friends, searchQuery]);

  const me = {
    ...profile,
    trophies: Object.values(trophies).reduce((acc, curr) => {
      acc += curr;
      return acc;
    }, 0),
    isSelf: true,
  };

  const renderTableFriend = (friend, index) => (
    <FriendTableRow key={friend.name} isSelf={friend.isSelf} alternateRow={index % 2 === 1}>
      <FriendTableCell>
        <FriendAvatar image={friend.avatar}>{friend.level}</FriendAvatar>
      </FriendTableCell>
      <FriendTableCell>
        <FriendName isSelf={friend.isSelf}>{friend.name}</FriendName>
      </FriendTableCell>
      <FriendTableCell>
        <FriendChallenge color={colors.gold}>{friend.trophies}</FriendChallenge>
      </FriendTableCell>
      <FriendTableCell>
        <FriendChallenge color={colors.fsDarkBlue}>{friend.achievements}</FriendChallenge>
      </FriendTableCell>
      <FriendTableCell>
        <FriendChallenge color={colors.fsCyan} spaced>
          <FriendChallengeText left>{friend.challengesWon}</FriendChallengeText>
          <FriendChallengeText center>—</FriendChallengeText>
          <FriendChallengeText>{friend.totalChallenges - friend.challengesWon}</FriendChallengeText>
        </FriendChallenge>
      </FriendTableCell>
    </FriendTableRow>
  );

  return (
    <Container center column width={500}>
      <SearchBar
        style={{ marginBottom: '10px' }}
        value={searchQuery}
        onChange={setSearchQuery}
        items={getFilteredUsers()}
        onSelect={(value) => console.log(value)}
        renderItem={(user) => (
          <ItemContainer>
            <FriendAvatar size={26} style={{ marginRight: '5px' }} image={user.avatar}>
              {user.level}
            </FriendAvatar>
            {user.name}
          </ItemContainer>
        )}
      />
      <SkillContainer height={500} flexStart full style={{ marginRight: 0, overflowY: 'auto' }}>
        <FriendTable>
          <FriendTableHead>
            <FriendTableRow>
              <FriendTableHeader>Level</FriendTableHeader>
              <FriendTableHeader>Name</FriendTableHeader>
              <FriendTableHeader center width={50}>
                T
              </FriendTableHeader>
              <FriendTableHeader center width={50}>
                A
              </FriendTableHeader>
              <FriendTableHeader center width={70}>
                C
              </FriendTableHeader>
            </FriendTableRow>
          </FriendTableHead>
          <FriendTableBody>
            {[...friends, me]
              .sort((a, b) => {
                if (a.weightedScore > b.weightedScore) {
                  return -1;
                }
                if (a.weightedScore < b.weightedScore) {
                  return 1;
                }
                return 0;
              })
              .map(renderTableFriend)}
          </FriendTableBody>
        </FriendTable>
      </SkillContainer>
    </Container>
  );
}
